import { TypePolicy } from '@apollo/client'
export const projectNuggetTypePolicy = {
    ProjectNugget: {
        keyFields: false,
    } as TypePolicy,
}
